import { FunctionComponent } from 'react';
import { FilterFieldName } from '../FilterBarContext';
import { useTranslation } from '@/lib';
import ListSelectFilter from './ListSelectFilter';
import { BatteryStatusSearchParam } from '@/modules/trackers/api/trackers/tracker.contracts';

const BatteryStatusFilter: FunctionComponent = () => {
  const filterFieldName = FilterFieldName.batteryStatus;
  const { t } = useTranslation();

  return (
    <ListSelectFilter
      label={t('battery_status')}
      filterFieldName={filterFieldName}
      options={[
        BatteryStatusSearchParam.HIGH,
        BatteryStatusSearchParam.MEDIUM,
        BatteryStatusSearchParam.LOW,
        BatteryStatusSearchParam.UNKNOWN,
        null,
      ]}
      renderOption={(item) => {
        switch (item) {
          case BatteryStatusSearchParam.HIGH:
            return t('battery_status_high');
          case BatteryStatusSearchParam.MEDIUM:
            return t('battery_status_medium');
          case BatteryStatusSearchParam.LOW:
            return t('battery_status_low');
          case BatteryStatusSearchParam.UNKNOWN:
            return t('battery_status_unknown');
          default:
            return <div className="italic">{t('all')}</div>;
        }
      }}
      valueExtractor={(item) => item}
    />
  );
};

export default BatteryStatusFilter;
